import React, { forwardRef } from 'react';
import './IconButton.css';

/**
 * Reusable icon button component with hover background and color
 * Used for card right-top buttons (like in ProfileTab header)
 * 
 * @param {Object} props
 * @param {React.ReactNode} props.children - Icon component (e.g., <Settings size={20}/>)
 * @param {Function} props.onClick - Click handler
 * @param {string} props.title - Tooltip text
 * @param {string} props.className - Additional CSS classes
 * @param {boolean} props.disabled - Disabled state
 */
const IconButton = forwardRef(({ 
  children, 
  onClick, 
  title, 
  className = '',
  disabled = false,
  ...rest 
}, ref) => {
  return (
    <button
      ref={ref}
      className={`icon-button ${className}`}
      onClick={onClick}
      title={title}
      disabled={disabled}
      {...rest}
    >
      {children}
    </button>
  );
});

IconButton.displayName = 'IconButton';

export default IconButton;

